import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import SwapsComponent from '../components/SwapsComponent'

const mapStateToProps = (state) => {
  return {
    swap: state.swap,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwapsComponent)
